import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { forwardRef, Type } from '@angular/core';

export function createComponentValueAccessor(cmp: any) {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => cmp),
    multi: true,
  };
}

export function createComponentValidator(cmp: Type<any>) {
  return {
    provide: NG_VALIDATORS,
    useExisting: cmp,
    multi: true,
  };
}
